import type { MyPageConfig } from '../../@types/context/my-page-config.types';
import { myPageOffersConfig } from './mypage-offers.config';

/**
 * Finnish market mypage offers preset.
 * Pre-merged with base config - brands just spread this directly.
 *
 * FI-specific: the SECCI document affordance (MV-2624). Loan-type tags — combo
 * (MV-1881) and top-up (MV-3201) — are global and live in the base preset.
 */
export const myPageOffersFiConfig: Pick<MyPageConfig['options'], 'offers'> = {
  offers: {
    ...myPageOffersConfig.offers,
    hasSecciDocument: true,
  },
};
